import React from 'react';
import { BOOKING_TRUST_POINTS } from '../../data/bookingExperienceData';

function BookingTrustStrip({ light = false }) {
	return (
		<ul className={`booking-trust${light ? ' booking-trust--light' : ''}`}>
			{BOOKING_TRUST_POINTS.map((point) => (
				<li key={point} className="booking-trust__item">{point}</li>
			))}
		</ul>
	);
}

export default BookingTrustStrip;
